export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7391.79877f94.jpg";